// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__1GDt_","input":"styles_input__2LNNW","title":"styles_title__AFc9C"};